import Service from '../Service'

export default class TipoProjetoService extends Service{

    constructor(){
        super('tipoprojeto');
    }
  
  }